import PropTypes from 'prop-types'
import { memo } from 'react'

import * as S from './styles'

export const Slider = memo(({ inputSliderProps, description, ...props }) => (
  <div {...props}>
    <S.Slider {...inputSliderProps} />
    <S.Description>{description}</S.Description>
  </div>
))

Slider.propTypes = {
  description: PropTypes.string,
  inputSliderProps: PropTypes.object.isRequired,
}

Slider.displayName = 'Slider'
